module.exports = __webpack_public_path__ + "static/media/36.942badd3.mp3";